const API_CONTROLLER = 'lesson/';
import HttpService from "@/utils/httpData";

export default {
    filter(pageIndex, pageSize, classId, subjectId, keyword, lessonType) {
        let params = {pageIndex, pageSize, classId, subjectId, keyword, lessonType }
        let apiEndpoint = `lesson/get-list`;
        return HttpService.get(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

    getById(id) {
        let params = {
            id: id
        }
        let apiEndpoint = `lesson/detail`;
        return HttpService.get(apiEndpoint, params)
                .then(res => {
                    return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
                })
                .catch(e => {return false}
        );
    },

    create(data) {        
        let params = JSON.stringify(data);
        let apiEndpoint = `lesson/create`;
        return HttpService.post(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

    update(data) {
        let params = JSON.stringify(data);
        let apiEndpoint = `lesson/update`;
        return HttpService.post(apiEndpoint, params)
            .then(res => {
                return res ? res : null;
            })
            .catch(e => {return false}
        );
    },

    delete(data) {
                
        let params = JSON.stringify(data);
        let apiEndpoint = `lesson/delete`;
        return HttpService.post(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

    upload(data) {
        let url = API_CONTROLLER + 'create-from-upload';
        return HttpService.post(url, JSON.stringify(data));
    },

    export(id) {
        let url = API_CONTROLLER + 'export';
        return HttpService.export(url, {
            id: id
        });
    },

    getLessonsSample (params) {
        let apiEndpoint = `library/list-book-lesson-plan`;
        return HttpService.post(apiEndpoint, params).then(res => {
            return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
        }).catch(e => { return false });
    },

    getLessonsSampleDetail (id) {
        let apiEndpoint = `library/detail?id=${id}`;
        return HttpService.get(apiEndpoint).then(res => {
            return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
        }).catch(e => { return false });
    }
}